import type { FunctionDef, ParameterDef } from '@thinkalpha/language-services';
import type {
    ConcreteIndicator,
    Indicator,
    IndicatorImport,
} from '@thinkalpha/platform-ws-client/contracts/dictionary.js';
import type { IndicatorTemplateColumn } from '@thinkalpha/ui-types/contracts/column-template';
import type {
    ConcreteIndicatorViewModel,
    FormulaPresetMatchViewModel,
    IndicatorFormulaViewModel,
    IndicatorImportViewModel,
    IndicatorParameterViewModel,
    PresetMatchViewModel,
} from '@thinkalpha/ui-types/contracts/dictionary-view-model';

/**
 * @deprecated
 */
export type IndicatorViewModelOrImportViewModel = ConcreteIndicatorViewModel | IndicatorImportViewModel;

/**
 * @deprecated
 */
export function isIndicatorViewModelImport(
    item: ConcreteIndicatorViewModel | IndicatorImportViewModel,
): item is IndicatorImportViewModel {
    return (item as IndicatorImportViewModel).alias !== undefined;
}

export function isIndicatorImport(item: ConcreteIndicator | IndicatorImport): item is IndicatorImport {
    return (item as IndicatorImport).alias !== undefined;
}

export function isIndicatorParameters(
    params: ParameterDef[] | IndicatorParameterViewModel[],
): params is IndicatorParameterViewModel[] {
    return !!(params as IndicatorParameterViewModel[]).map((x) => x.bars);
}

/**
 * @deprecated
 */
export interface DictionaryViewModelFunctionDef extends FunctionDef {
    indicator: IndicatorViewModelOrImportViewModel;
    alias?: string;
}

export interface DictionaryFunctionDef extends FunctionDef {
    indicator: Indicator | IndicatorImport;
    alias?: string;
}

/**
 * @deprecated
 */
export function isDictionaryViewModelFunctionDef(
    x: DictionaryViewModelFunctionDef | FunctionDef,
): x is DictionaryViewModelFunctionDef {
    return !!(x as DictionaryViewModelFunctionDef).indicator;
}

export function isDictionaryFunctionDef(x: DictionaryFunctionDef | FunctionDef): x is DictionaryFunctionDef {
    return !!(x as DictionaryFunctionDef).indicator;
}

export function isFormulaPresetMatch(preset: PresetMatchViewModel): preset is FormulaPresetMatchViewModel {
    return !!(preset as FormulaPresetMatchViewModel).imports;
}

export type IndImportDiffSettings = {
    prevImport: IndicatorImportViewModel;
    newInd: ConcreteIndicatorViewModel;
};

export type IndImportDiff = {
    name?: { prev: string; new: string };
    symbol?: { prev: string; new: string };
    formula?: { prev: string; new: string };
    imports?: { prev: string; new: string };
    description?: { prev: string; new: string };
    synonyms?: { prev: string[]; new: string[] };
    tags?: { prev: string[]; new: string[] };
    notes?: { prev: string; new: string };
};

export function isIndicatorFormula(
    formula: IndicatorFormulaViewModel | IndicatorTemplateColumn,
): formula is IndicatorFormulaViewModel {
    return !!(formula as IndicatorFormulaViewModel).imports;
}
